import { registerTab } from "lib/@components/tabs"
import { SkillMappingsTab } from "./skill-mappings-tab"

registerTab({
    tab: "optimiser",
    id: "skill-mappings",
    title: "Skill Mappings",
    content: <SkillMappingsTab $lazy priority={30} />,
})
